(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('CATEGORIA_NOVEDAD_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<categoria-novedad-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></categoria-novedad-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (CategoriaNovedad) {
                        return new CategoriaNovedad();
                    }
                }
            }
        });
})();
